export interface SelectOptions {
  id: string;
  name: string;
}

export const abbreviatedStates: SelectOptions[] = [
  { id: 'AC', name: 'AC' },
  { id: 'AL', name: 'AL' },
  { id: 'AM', name: 'AM' },
  { id: 'BA', name: 'BA' },
  { id: 'CE', name: 'CE' },
  { id: 'DF', name: 'DF' },
  { id: 'ES', name: 'ES' },
  { id: 'GO', name: 'GO' },
  { id: 'MA', name: 'MA' },
  { id: 'MT', name: 'MT' },
  { id: 'MS', name: 'MS' },
  { id: 'MG', name: 'MG' },
  { id: 'PA', name: 'PA' },
  { id: 'PB', name: 'PB' },
  { id: 'PR', name: 'PR' },
  { id: 'PE', name: 'PE' },
  { id: 'PI', name: 'PI' },
  { id: 'RJ', name: 'RJ' },
  { id: 'RN', name: 'RN' },
  { id: 'RS', name: 'RS' },
  { id: 'RO', name: 'RO' },
  { id: 'RR', name: 'RR' },
  { id: 'SC', name: 'SC' },
  { id: 'SP', name: 'SP' },
  { id: 'SE', name: 'SE' },
  { id: 'TO', name: 'TO' },
];

export const states: SelectOptions[] = [
  { id: 'Acre', name: 'Acre' },
  { id: 'Alagoas', name: 'Alagoas' },
  { id: 'Amapá', name: 'Amapá' },
  { id: 'Bahia', name: 'Bahia' },
  { id: 'Ceará', name: 'Ceará' },
  { id: 'Distrito Federal', name: 'Distrito federal' },
  { id: 'Espírito Santo', name: 'Espírito Santo' },
  { id: 'Goiás', name: 'Goiás' },
  { id: 'Maranhão', name: 'Maranhão' },
  { id: 'Mato Grosso', name: 'Mato Grosso' },
  { id: 'Mato Grosso do Sul', name: 'Mato Grosso do Sul' },
  { id: 'Minas Gerais', name: 'Minas Gerais' },
  { id: 'Pará', name: 'Pará' },
  { id: 'Paraíba', name: 'Paraíba' },
  { id: 'Paraná', name: 'Paraná' },
  { id: 'Pernambuco', name: 'Pernambuco' },
  { id: 'Piauí', name: 'Piauí' },
  { id: 'Rio de Janeiro', name: 'Rio de Janeiro' },
  { id: 'Rio Grande do Norte', name: 'Rio Grande do Norte' },
  { id: 'Rio Grande do Sul', name: 'Rio Grande do Sul' },
  { id: 'Rondônia', name: 'Rondônia' },
  { id: 'Roraima', name: 'Roraima' },
  { id: 'Santa Catarina', name: 'Santa Catarina' },
  { id: 'São Paulo', name: 'São Paulo' },
  { id: 'Sergipe', name: 'Sergipe' },
  { id: 'Tocantins', name: 'Tocantins' },
];
